export default __webpack_public_path__ + "static/media/yellow_large.33f5dca3.png";